export enum DomainPlatformValue {
  Ipe = 'ipe',
  Fs = 'fs',
}

export default function getDomainPlatform(): DomainPlatformValue | undefined {
  if (
    process.env.PLATFORM === DomainPlatformValue.Ipe ||
    window.location.hostname.endsWith('ipe.courseware.bj33smarter.com') ||
    window.location.hostname.endsWith('ipe.courseware.staging.bj33smarter.com')
  ) {
    return DomainPlatformValue.Ipe;
  }

  if (
    process.env.PLATFORM === DomainPlatformValue.Fs ||
    window.location.hostname.endsWith('fs.courseware.bj33smarter.com') ||
    window.location.hostname.endsWith('fs.courseware.staging.bj33smarter.com')
  ) {
    return DomainPlatformValue.Fs;
  }

  return undefined;
}
